import {
  Dialog,
  DialogContent,
  DialogHeader,
  Link,
  Modal,
  Text,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

type CannotDeclineModalProps = {
  show: boolean;
  onClose: () => void;
};

export function CannotDeclineModal({ show, onClose }: CannotDeclineModalProps) {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <Modal isOpen={show}>
      <Dialog width="456px">
        {() => (
          <>
            <DialogHeader onClose={onClose}>
              {t("Decline request")}
            </DialogHeader>
            <DialogContent>
              <>
                <div>
                  <Text style="global/body-primary">
                    <Trans>
                      You are unable to decline this request as you have started
                      the Identity Verification session. Please contact{" "}
                      <Link
                        linkStyle="default"
                        textColor="text-accent-tofino"
                        href="mailto: support@certn.co"
                        testID="support-email-link"
                        target="_blank"
                      >
                        support@certn.co
                      </Link>
                      .
                    </Trans>
                  </Text>
                </div>
              </>
            </DialogContent>
          </>
        )}
      </Dialog>
    </Modal>
  );
}
